import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderFileExplorerWithSelectedListComponent } from './file-explorer-with-selected-list.component';
import { RappiderFileExplorerModule } from '../file-explorer/file-explorer.module';
import { RappiderListGridModule } from '../list-grid/list-grid.module';
import { RappiderIconModule } from '../icon/icon.module';


@NgModule({
  declarations: [
    RappiderFileExplorerWithSelectedListComponent
  ],
  imports: [
    CommonModule,
    RappiderFileExplorerModule,
    RappiderListGridModule,
    RappiderIconModule
  ],
  exports: [
    RappiderFileExplorerWithSelectedListComponent
  ]
})
export class RappiderFileExplorerWithSelectedListModule { }
